module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.eot?541e65fb46e44ecdf7a9da8a9b881446";